<template>
  <div class="common-limit">
    <Breadcrumb></Breadcrumb>
    <el-row :gutter="20" style="margin-top: 10px">
      <el-col :span="24" :xs="24">
        <el-card style="margin-bottom: 12px">
          <el-row :gutter="10">
            <el-col :span="3">
              <userAvatar :user="user" :customSize="true" />
            </el-col>
            <el-col :span="5" style="line-height: 40px">
              <div>
                {{ name }}
              </div>
              <div v-if="(!user.authStatus || user.authStatus == '01') && user.userType == '01'">
                实名认证：
                <el-button
                  @click="handleJump('/system/account/auth')"
                  type="text"
                  >未认证，点此认证</el-button
                >
              </div>
              <div v-if="user.userType == '02'">
                {{ user.nickName }}
              </div>

              <div v-if="user.authStatus == '02' && user.userType == '01'">
                实名认证：
                <el-button type="text">待审核</el-button>
              </div>
              <div v-if="user.authStatus == '03' && user.userType == '01'">
                {{ user.enterprise ? user.enterprise : user.nickName }}
                <el-button type="text">已认证</el-button>
              </div>
              <div v-if="user.authStatus == '04' && user.userType == '01'">
                实名认证不通过，{{ user.authOpinion }}
                <el-button
                  @click="handleJump('/system/account/auth')"
                  type="text"
                  >重新认证</el-button
                >
              </div>
            </el-col>
            <el-col
              style="line-height: 40px; border-right: 1px solid #dddddd"
              :span="6"
            >
              <div>
                <img style="width: 40px; margin: 0 6px 0 0" :src="getImage" />{{
                  vipName
                }}
                <el-button
                  v-if="user.userType != '02'"
                  @click="handleJump('/system/account/purchaseMember')"
                  size="small"
                  type="primary"
                  style="margin: 0 0 0 8px"
                  >升级会员</el-button
                >
              </div>
              <div>
                （到期时间：{{
                  user.expireDate
                    ? user.expireDate.substring(0, 10)
                    : "永久有效"
                }}）
              </div>
            </el-col>
            <el-col style="line-height: 40px; text-align: center" :span="4">
              <div style="font-size: 19px; color: #f25551; font-weight: bold">
                ￥{{ user.balance }}
              </div>
              <div style="text-align: center">账户余额</div>
            </el-col>
            <el-col style="line-height: 80px; text-align: center" :span="3">
              <el-button
                @click="handleJump('/system/account/recharge')"
                size="small"
                type="primary"
                >充值</el-button
              >
            </el-col>
            <el-col style="line-height: 80px; text-align: center" :span="3">
              <el-button
                v-if="user.userType != '02'"
                @click="handleJump('/system/account/withdrawal')"
                size="small"
                type="primary"
                >提现</el-button
              >
            </el-col>
          </el-row>
        </el-card>
        <el-card style="margin-bottom: 12px">
          <div slot="header">个人资料</div>
          <div>
            <el-row :gutter="24">
              <el-col :span="8" class="line-height-40">
                <span class="user-title">账号类型：</span>{{ accountName }}
              </el-col>
            </el-row>
            <el-row :gutter="24">
              <el-col :span="8" class="line-height-40">
                <span class="user-title">手机：</span>{{ user.phoneNumber }}
              </el-col>
              <el-col :span="16">
                <el-button type="text" @click="handleEdit('phoneNumber')"
                  >修改</el-button
                >
              </el-col>
            </el-row>
            <el-row :gutter="24">
              <el-col :span="8" class="line-height-40">
                <span class="user-title">密码：</span>*****
              </el-col>
              <el-col :span="16">
                <el-button type="text" @click="handleEdit('pwd')"
                  >修改</el-button
                >
              </el-col>
            </el-row>
            <el-row :gutter="24">
              <el-col :span="8" class="line-height-40">
                <span class="user-title">邮箱：</span>{{ user.email }}
              </el-col>
              <el-col :span="16">
                <el-button type="text" @click="handleEdit('email')"
                  >修改</el-button
                >
              </el-col>
            </el-row>
            <el-row :gutter="24">
              <el-col :span="8" class="line-height-40">
                <span class="user-title">公司：</span>{{ user.company }}
              </el-col>
              <el-col :span="16">
                <el-button type="text" @click="handleEdit('company')"
                  >修改</el-button
                >
              </el-col>
            </el-row>
            <el-row :gutter="24">
              <el-col :span="8" class="line-height-40">
                <span class="user-title">微信：</span>{{ user.wechat }}
              </el-col>
              <el-col :span="16">
                <el-button type="text" @click="handleEdit('wechat')"
                  >修改</el-button
                >
              </el-col>
            </el-row>
            <el-row :gutter="24">
              <el-col :span="8" class="line-height-40">
                <span class="user-title">注册时间：</span>{{ user.createTime }}
              </el-col>
            </el-row>
          </div>
        </el-card>
        <el-card v-if="user.userType != '02'" style="margin-bottom: 12px">
          <div slot="header">购买增值服务</div>
          <el-row :gutter="24">
            <el-col :span="6" class="line-height-40">
              设计次数
              <el-button
                style="margin: 0 0 0 19px"
                size="mini"
                type="primary"
                @click="
                  handleJump(
                    '/system/account/purchaseMember?type=2&service=DESIGN'
                  )
                "
                >购买</el-button
              >
            </el-col>
            <el-col :span="6" class="line-height-40">
              图库容量
              <el-button
                style="margin: 0 0 0 19px"
                size="mini"
                type="primary"
                @click="
                  handleJump(
                    '/system/account/purchaseMember?type=2&service=MAP'
                  )
                "
                >购买</el-button
              ></el-col
            >
            <el-col :span="6" class="line-height-40">
              店铺数量
              <el-button
                style="margin: 0 0 0 19px"
                size="mini"
                type="primary"
                @click="
                  handleJump(
                    '/system/account/purchaseMember?type=2&service=SHOP'
                  )
                "
                >购买</el-button
              ></el-col
            >
            <el-col :span="6" class="line-height-40">
              子账号数量
              <el-button
                style="margin: 0 0 0 19px"
                size="mini"
                type="primary"
                @click="
                  handleJump(
                    '/system/account/purchaseMember?type=2&service=ACCOUNT'
                  )
                "
                >购买</el-button
              ></el-col
            >
          </el-row>
        </el-card>
        <el-card
          v-if="user.userType != '02'"
          class="chart-info"
          style="padding-bottom: 0px; margin-bottom: 12px"
        >
          <div slot="header">设计次数</div>
          <el-row :gutter="24">
            <el-col :span="5" class="line-height-40 volume-box">
              <div style="width: 300px; height: 300px" id="designTimes"></div>
              <div class="chart-center-text">
                <p>
                  设计次数：{{ userInfo.length > 0 ? userInfo[0].total : 0 }}
                </p>
                <p class="">已使用</p>
                <p class="red f20">
                  {{ userInfo.length > 0 ? userInfo[0].used : 0 }}次
                </p>
              </div>
            </el-col>
            <el-col style="padding: 0 60px" :span="19">
              <el-row :gutter="24">
                <el-col :span="8" class="line-height-40">
                  总量：{{ userInfo.length > 0 ? userInfo[0].total : 0 }}
                </el-col>
                <el-col :span="8" class="line-height-40">
                  已使用：{{ userInfo.length > 0 ? userInfo[0].used : 0 }}
                </el-col>
                <el-col :span="8" class="line-height-40">
                  剩余：
                  {{ userInfo.length > 0 ? userInfo[0].left : 0 }}</el-col
                >
              </el-row>
              <el-table border="" :data="designList" style="width: 100%">
                <el-table-column prop="serviceType" label="获取途径">
                </el-table-column>
                <el-table-column prop="times" label="设计数量">
                </el-table-column>
                <el-table-column prop="expireDate" label="截止日期">
                  <template slot-scope="scope">
                    {{
                      scope.row.expireDate
                        ? formatDate(scope.row.expireDate)
                        : ""
                    }}
                  </template>
                </el-table-column>
              </el-table></el-col
            >
          </el-row>
        </el-card>
        <el-card
          v-if="user.userType != '02'"
          class="chart-info"
          style="padding-bottom: 0px; margin-bottom: 12px"
        >
          <div slot="header">图库容量</div>
          <el-row :gutter="24">
            <el-col :span="5" class="line-height-40 volume-box">
              <div style="width: 300px; height: 300px" id="picSpace"></div>
              <div class="chart-center-text">
                <p>
                  图库容量：{{ userInfo.length > 0 ? userInfo[1].total : 0 }}G
                </p>
                <p class="">已使用</p>
                <p class="red f20">
                  {{ userInfo.length > 0 ? userInfo[1].used : 0 }}G
                </p>
              </div>
            </el-col>
            <el-col style="padding: 0 60px" :span="19">
              <el-row :gutter="24">
                <el-col :span="8" class="line-height-40">
                  总量：{{ userInfo.length > 0 ? userInfo[1].total : 0 }}G
                </el-col>
                <el-col :span="8" class="line-height-40">
                  已使用：{{ userInfo.length > 0 ? userInfo[1].used : 0 }}G
                </el-col>
                <el-col :span="8" class="line-height-40">
                  剩余：
                  {{ userInfo.length > 0 ? userInfo[1].left : 0 }}G</el-col
                >
              </el-row>
              <el-table border="" :data="picSpaceList" style="width: 100%">
                <el-table-column prop="serviceType" label="获取途径">
                </el-table-column>
                <el-table-column prop="times" label="图库容量(G)">
                  <template slot-scope="scope">
                    {{ (scope.row.times / 1024).toFixed(2) }}
                  </template>
                </el-table-column>
                <el-table-column prop="expireDate" label="截止日期">
                  <template slot-scope="scope">
                    {{
                      scope.row.expireDate
                        ? formatDate(scope.row.expireDate)
                        : ""
                    }}
                  </template>
                </el-table-column>
              </el-table></el-col
            >
          </el-row>
        </el-card>
        <el-card
          v-if="user.userType != '02'"
          class="chart-info"
          style="padding-bottom: 0px; margin-bottom: 12px"
        >
          <div slot="header">店铺数量</div>
          <el-row :gutter="24">
            <el-col :span="5" class="line-height-40 volume-box">
              <div style="width: 300px; height: 300px" id="shopNum"></div>
              <div class="chart-center-text">
                <p>
                  店铺数量：{{ userInfo.length > 0 ? userInfo[2].total : 0 }}
                </p>
                <p class="">已使用</p>
                <p class="red f20">
                  {{ userInfo.length > 0 ? userInfo[2].used : 0 }}个
                </p>
              </div>
            </el-col>
            <el-col style="padding: 0 60px" :span="19">
              <el-row :gutter="24">
                <el-col :span="8" class="line-height-40">
                  总量：{{ userInfo.length > 0 ? userInfo[2].total : 0 }}
                </el-col>
                <el-col :span="8" class="line-height-40">
                  已使用：{{ userInfo.length > 0 ? userInfo[2].used : 0 }}
                </el-col>
                <el-col :span="8" class="line-height-40">
                  剩余：
                  {{ userInfo.length > 0 ? userInfo[2].left : 0 }}</el-col
                >
              </el-row>
              <el-table border="" :data="shopNumList" style="width: 100%">
                <el-table-column prop="serviceType" label="获取途径">
                </el-table-column>
                <el-table-column prop="times" label="店铺数量">
                </el-table-column>
                <el-table-column prop="expireDate" label="截止日期">
                  <template slot-scope="scope">
                    {{
                      scope.row.expireDate
                        ? formatDate(scope.row.expireDate)
                        : ""
                    }}
                  </template>
                </el-table-column>
              </el-table></el-col
            >
          </el-row>
        </el-card>
        <el-card
          v-if="user.userType != '02'"
          class="chart-info"
          style="padding-bottom: 0px; margin-bottom: 12px"
        >
          <div slot="header">子账号数量</div>
          <el-row :gutter="24">
            <el-col :span="5" class="line-height-40 volume-box">
              <div style="width: 300px; height: 300px" id="accountNum"></div>
              <div class="chart-center-text">
                <p>
                  子账号数量：{{ userInfo.length > 0 ? userInfo[3].total : 0 }}
                </p>
                <p class="">已使用</p>
                <p class="red f20">
                  {{ userInfo.length > 0 ? userInfo[3].used : 0 }}个
                </p>
              </div>
            </el-col>
            <el-col style="padding: 0 60px" :span="19">
              <el-row :gutter="24">
                <el-col :span="8" class="line-height-40">
                  总量：{{ userInfo.length > 0 ? userInfo[3].total : 0 }}
                </el-col>
                <el-col :span="8" class="line-height-40">
                  已使用：{{ userInfo.length > 0 ? userInfo[3].used : 0 }}
                </el-col>
                <el-col :span="8" class="line-height-40">
                  剩余：
                  {{ userInfo.length > 0 ? userInfo[3].left : 0 }}</el-col
                >
              </el-row>
              <el-table border="" :data="accountNumList" style="width: 100%">
                <el-table-column prop="serviceType" label="获取途径">
                </el-table-column>
                <el-table-column prop="times" label="子账号数量">
                </el-table-column>
                <el-table-column prop="expireDate" label="截止日期">
                  <template slot-scope="scope">
                    {{
                      scope.row.expireDate
                        ? formatDate(scope.row.expireDate)
                        : ""
                    }}
                  </template>
                </el-table-column>
              </el-table></el-col
            >
          </el-row>
        </el-card>
      </el-col>
    </el-row>

    <el-dialog
      :close-on-click-modal="false"
      title="编辑"
      :visible.sync="editVisible"
      destroyOnClose
    >
      <el-form :model="form" ref="form" label-width="96px" :rules="rules">
        <el-form-item
          v-if="showType === 'nickName'"
          prop="nickName"
          label="姓名"
        >
          <el-input
            v-model="form.nickName"
            placeholder="请输入真实姓名，设置后不能修改"
          ></el-input>
        </el-form-item>

        <el-form-item
          v-if="showType === 'phoneNumber'"
          prop="oldSmsCode"
          label="短信验证码"
        >
          <el-input
            style="width: 319px; float: left"
            v-model="form.oldSmsCode"
            placeholder="请输入旧的手机短信验证码"
            maxlength="6"
          >
            <template slot="append"
              ><span
                v-if="!isSendOld"
                style="cursor: pointer"
                @click="handleSendMessageOld"
                >发送验证码</span
              ><span v-if="isSendOld">{{ remainOld }} s</span></template
            >
          </el-input>
        </el-form-item>
        <el-form-item
          v-if="showType === 'phoneNumber'"
          prop="phoneNumber"
          label="新的手机"
        >
          <el-input
            v-model="form.phoneNumber"
            placeholder="请输入要绑定的手机号码"
            maxlength="11"
          >
          </el-input>
        </el-form-item>
        <el-form-item
          v-if="showType === 'phoneNumber'"
          prop="imgCode"
          label="验证码"
        >
          <el-input
            style="width: 200px; float: left"
            v-model="form.imgCode"
            placeholder="请输入验证码"
            @keyup.enter.native="handleRegister"
          >
          </el-input>
          <img
            style="float: left; height: 40px; margin-left: 12px"
            :src="codeUrl"
            @click="getCode"
          />
        </el-form-item>
        <el-form-item
          v-if="showType === 'phoneNumber'"
          prop="smsCode"
          label="短信验证码"
        >
          <el-input
            style="width: 319px; float: left"
            v-model="form.smsCode"
            placeholder="请输入新的手机短信验证码"
            maxlength="6"
          >
            <template slot="append"
              ><span
                v-if="!isSend"
                style="cursor: pointer"
                @click="handleSendMessage"
                >发送验证码</span
              ><span v-if="isSend">{{ remain }} s</span></template
            >
          </el-input>
        </el-form-item>
        <el-form-item v-if="showType === 'email'" prop="email" label="邮箱">
          <el-input
            v-model="form.email"
            placeholder="请输入邮箱地址"
            maxlength="50"
          ></el-input>
        </el-form-item>
        <el-form-item v-if="showType === 'company'" label="公司">
          <el-input v-model="form.company" placeholder="请输入公司"></el-input>
        </el-form-item>
        <el-form-item v-if="showType === 'wechat'" label="微信">
          <el-input v-model="form.wechat" placeholder="请输入微信号"></el-input>
        </el-form-item>
        <template v-if="showType === 'pwd'">
          <resetPassword
            ref="resetPwd"
            @handleRequestDone="handleRequestDone"
            @handleStartRequest="handleStartRequest"
            :user="user"
          />
        </template>
      </el-form>
      <div slot="footer">
        <el-button type="primary" @click="handleSave" :loading="loading"
          >确定</el-button
        >
        <el-button @click="handleCancel">取消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import userAvatar from "./profile/userAvatar"
import resetPassword from "./profile/resetPassword"
import Breadcrumb from "@/components/common/Breadcrumb"
import {
  getUserProfile,
  updateUserProfile,
  updateMobile,
  sendUserCodeSms,
} from "@/api/system/user"
import { getCodeImg, sendSms } from "@/api/login"
import { mapGetters } from "vuex"
import vip0 from "@/assets/images/user/vip0.png"
import vip1 from "@/assets/images/user/vip1.png"
import vip2 from "@/assets/images/user/vip2.png"
import vip3 from "@/assets/images/user/vip3.png"
import vip4 from "@/assets/images/user/vip4.png"
import vip5 from "@/assets/images/user/vip5.png"

import { getPersonInfo } from "@/api/mine/service"
var echarts = require("echarts/lib/echarts")
// 引入柱状图
require("echarts/lib/chart/pie")
// 引入提示框和标题组件
require("echarts/lib/component/tooltip")
require("echarts/lib/component/title")
import moment from "moment"

export default {
  components: { Breadcrumb, userAvatar, resetPassword },
  data: function () {
    return {
      user: {},
      userExt: {},
      roleGroup: {},
      postGroup: {},
      form: {
        imgCode: "",
        smsCode: "",
        oldSmsCode: "",
        phoneNumber: "",
        uuid: "",
      },
      showType: "",
      editVisible: false,
      loading: false,
      rules: {
        nickName: [
          { required: true, message: "用户姓名不能为空", trigger: "blur" },
          { min: 1, max: 20, message: "昵称度在1到20个字符", trigger: "blur" },
        ],
        email: [
          { required: true, message: "邮箱地址不能为空", trigger: "blur" },
          {
            type: "email",
            message: "'请输入正确的邮箱地址",
            trigger: ["blur", "change"],
          },
        ],
        phoneNumber: [
          { required: true, message: "手机号码不能为空", trigger: "blur" },
          {
            pattern: /^1[3|4|5|6|7|8|9][0-9]\d{8}$/,
            message: "请输入正确的手机号码",
            trigger: "blur",
          },
        ],
        imgCode: [
          { required: true, message: "图片验证码不能为空", trigger: "blur" },
        ],
        smsCode: [
          { required: true, message: "短信验证码不能为空", trigger: "blur" },
        ],
        oldSmsCode: [
          { required: true, message: "短信验证码不能为空", trigger: "blur" },
        ],
      },
      isSend: false,
      remain: 60,
      codeUrl: "",
      smsCode: "",
      isSendOld: false,
      remainOld: 60,
      userInfo: [],
      designList: [],
      picSpaceList: [],
      shopNumList: [],
      accountNumList: [],
    }
  },
  computed: {
    ...mapGetters(["name", "nickName", "avatar", "permission_routes", "stat"]),
    accountName() {
      if (this.user.userType == "00") {
        return "管理员"
      } else if (this.user.userType == "01") {
        return "主账号"
      } else {
        return "子账号"
      }
    },
    getImage() {
      if (this.user.vipType == "0" || !this.user.vipType) {
        return vip0
      } else if (this.user.vipType == "1") {
        return vip1
      } else if (this.user.vipType == "2") {
        return vip2
      } else if (this.user.vipType == "3") {
        return vip3
      } else if (this.user.vipType == "4") {
        return vip4
      } else if (this.user.vipType == "5") {
        return vip5
      }
    },
    vipName() {
      if (this.user.vipType == "0" || !this.user.vipType) {
        return "免费版"
      } else if (this.user.vipType == "1") {
        return "创业板"
      } else if (this.user.vipType == "2") {
        return "专业版"
      } else if (this.user.vipType == "3") {
        return "企业版"
      }
    },
  },
  created() {
    this.getUser()
    this.getPersonInfo()
  },
  methods: {
    handleJump(path) {
      this.$router.push({ path: path })
    },
    getUser() {
      getUserProfile().then((response) => {
        this.user = response.user
        this.roleGroup = response.roleGroup
        this.postGroup = response.postGroup
      })
    },
    getPersonInfo() {
      getPersonInfo().then((response) => {
        this.userInfo = response.data
        this.designList = this.userInfo[0].detail
        this.picSpaceList = this.userInfo[1].detail
        this.shopNumList = this.userInfo[2].detail
        this.accountNumList = this.userInfo[3].detail

        this.userInfo[1].total = Number((this.userInfo[1].total / 1024).toFixed(2))
        this.userInfo[1].used = Number((this.userInfo[1].used / 1024).toFixed(2))
        this.userInfo[1].left = Number((this.userInfo[1].left / 1024).toFixed(2))

        this.drawChart(this.userInfo[0], "#designTimes", "设计次数", "#f4a63a")
        this.drawChart(this.userInfo[1], "#picSpace", "图片空间", "#f8725c")
        this.drawChart(this.userInfo[2], "#shopNum", "店铺数量", "#da71e4")
        this.drawChart(this.userInfo[3], "#accountNum", "子账号数量", "#a185ee")
      })
    },

    /* 编辑 */
    handleEdit(type) {
      if (type == "phoneNumber") {
        this.getCode()
      }
      this.showType = type
      this.editVisible = true
    },
    /* 保存修改对应表单数据 */
    handleSave() {
      switch (this.showType) {
        case "pwd":
          this.$refs.resetPwd.submit()
          break
        case "phoneNumber":
          this.updateProfile("phoneNumber")
          break
        case "email":
          this.updateProfile("email")
          break
        case "nickName":
          this.updateProfile("nickName")
          break
        case "company":
          this.updateProfile("company")
          break
        case "wechat":
          this.updateProfile("wechat")
          break
      }
    },
    /* 关闭模态框 */
    handleCancel() {
      this.editVisible = false
    },
    /* 请求开始回调 */
    handleStartRequest() {
      this.loading = true
    },
    /* 请求结束回调 */
    handleRequestDone(status) {
      this.loading = false
      if (status) {
        this.editVisible = false
        this.form = {}
      }
    },
    /* 更新基本信息 */
    async updateProfile(formType) {
      this.$refs["form"].validate(async (valid) => {
        if (valid) {
          this.loading = true
          let params = Object.assign({}, this.user)
          params = Object.assign(params, this.form)
          if (formType == "phoneNumber") {
            try {
              let result = await updateMobile(
                this._.pick(
                  params,
                  "phoneNumber",
                  "imgCode",
                  "smsCode",
                  "uuid",
                  "oldSmsCode"
                )
              )
              if (result.code == 200) {
                this.msgSuccess("修改成功")
                this.editVisible = false
                this.getUser()
                this.loading = false
                this.handleRequestDone()
              }
            } catch (error) {
              this.loading = false
            }
          } else {
            updateUserProfile(this._.pick(params, formType))
              .then((res) => {
                if (res.code === 200) {
                  this.msgSuccess("修改成功")
                  this.editVisible = false
                  this.getUser()
                }
              })
              .finally(() => {
                this.loading = false
                this.handleRequestDone()
              })
          }
        }
      })
    },
    async handleSendMessage() {
      try {
        if (this.isSend) {
          return
        }
        let _self = this

        let result = await sendSms({
          phoneNumber: this.form.phoneNumber,
          imgCode: this.form.imgCode,
          uuid: this.form.uuid,
          type: "3",
        })
        if (result.code == 200) {
          let timer = window.setInterval(() => {
            _self.remain = Number(_self.remain) - 1
            if (this.remain == 0) {
              window.clearInterval(timer)
              _self.remain = 60
              this.isSend = false
            }
          }, 1000)
          this.isSend = true
          this.msgSuccess("短信发送成功")
        } else {
          this.getCode()
        }
      } catch (error) {}
    },
    async handleSendMessageOld() {
      try {
        if (this.isSendOld) {
          return
        }
        let _self = this

        let result = await sendUserCodeSms()
        if (result.code == 200) {
          let timer = window.setInterval(() => {
            _self.remainOld = Number(_self.remainOld) - 1
            if (this.remainOld == 0) {
              window.clearInterval(timer)
              _self.remainOld = 60
              this.isSendOld = false
            }
          }, 1000)
          this.isSendOld = true
          this.msgSuccess("短信发送成功")
        } else {
          this.getCode()
        }
      } catch (error) {}
    },
    getCode() {
      getCodeImg().then((res) => {
        this.codeUrl = "data:image/gif;base64," + res.img
        this.form.uuid = res.uuid
      })
    },
    async drawChart(data, dom, title, color) {
      // 基于准备好的dom，初始化echarts实例
      let myChart = echarts.init(document.querySelector(dom))
      // 指定图表的配置项和数据
      let option = {
        tooltip: {
          trigger: "item",
          formatter: "{b}（{d}%）",
        },
        legend: {
          orient: "vertical",
          left: "left",
        },
        label: {
          show: false,
          position: "center",
          formatter: "{d}%",
        },
        series: [
          {
            name: title,
            type: "pie",
            radius: ["60%", "70%"],
            data: [
              {
                value: ((data.used / (data.used + data.left)) * 100).toFixed(2),
                name: `已使用：${data.used}`,
              },
              {
                value: ((data.left / (data.used + data.left)) * 100).toFixed(2),
                name: `未使用：${data.left}`,
              },
            ],
            color: [color, "#aaaaaa"],
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: "rgba(0, 0, 0, 0.5)",
              },
            },
          },
        ],
      }
      // 使用刚指定的配置项和数据显示图表。
      myChart.setOption(option)
    },
    formatDate(origin) {
      return moment(origin).format("yyyy-MM-DD")
    },
  },
}
</script>
<style scoped>
.list-group {
  padding-left: 0px;
  list-style: none;
}
.list-group-striped > .list-group-item {
  border-left: 0;
  border-right: 0;
  border-radius: 0;
  padding-left: 0;
  padding-right: 0;
}
.list-group-item {
  border-bottom: 1px solid #e7eaec;
  border-top: 1px solid #e7eaec;
  margin-bottom: -1px;
  padding: 11px 0px;
  font-size: 13px;
}
.pull-right {
  float: right !important;
}
.text-center {
  text-align: center;
}
.min-height {
  min-height: 500px;
}
.balance {
  color: #ff1d1d;
}
.account-button {
  cursor: default;
  color: #ffffff;
  background-color: #0064c8;
  border: 1px solid var(--cb-color-border-accent, #0064c8);
  margin: 0 8px 0px 5px;
  padding: 0px 8px;
  border-radius: 100px;
  line-height: 1.7em;
  font-size: 0.95em;
  overflow: hidden;
  vertical-align: middle;
  text-align: center;
  display: inline-block;
  width: auto;
}

.chart-info ::v-deep .el-card__body {
  padding-bottom: 0px;
}

.volume-box .chart-center-text {
  position: absolute;
  left: 87px;
  top: 103px;
  text-align: center;
  line-height: 30px;
  width: 150px;
}
.red {
  color: #ff4d3a !important;
}
.f20 {
  font-size: 20px;
}
.mt5 {
  margin-top: 5px !important;
}
.user-title {
  width: 80px;
  text-align: right;
  display: inline-block;
}
</style>
